import React from 'react';
import Input from '../../../components/ui/Input';
// Assuming 'cn' is a utility for combining class names, if not, you can remove it.
// import { cn } from '../../../lib/utils'; 

const PersonalInformation = ({ 
  formData, 
  onFormChange, 
  errors = {} 
}) => {
  return (
    <div className="space-y-6">
      {/* Personal Information Section */}
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Personal Information</h3>
        <p className="text-sm text-muted-foreground mb-6">
          Please provide your contact details.
        </p>
        
        <div className="space-y-4">
          {/* Full Name Input */}
          <Input
            label="Full Name"
            type="text"
            placeholder="e.g., John Doe"
            value={formData.name || ''}
            onChange={(e) => onFormChange('name', e.target.value)}
            error={errors.name}
            required
            description="Your full name as it appears on official documents."
          />

          {/* Email Input */}
          <Input
            label="Email Address"
            type="email"
            placeholder="e.g., john.doe@example.com"
            value={formData.email || ''}
            onChange={(e) => onFormChange('email', e.target.value)}
            error={errors.email}
            required
            description="We'll use this to send you updates."
          />

          {/* Phone Number Input */}
          <Input
            label="Phone Number"
            type="tel" // Use 'tel' for better mobile keyboard experience
            placeholder="e.g., +30 690 123 4567"
            value={formData.phone || ''}
            onChange={(e) => onFormChange('phone', e.target.value)}
            error={errors.phone}
            required
            description="Your primary contact number."
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
